import {
  AutocompleteInput,
  BooleanInput,
  Button,
  ChipField,
  CloneButton, //
  Create,
  Datagrid,
  DeleteWithConfirmButton,
  Edit,
  ExportButton,
  Filter,
  FormDataConsumer,
  FunctionField,
  ImageField,
  ImageInput,
  List,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  required,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
  Toolbar,
  TopToolbar,
  useNotify,
  useRecordContext,
  useRedirect,
} from "react-admin";

import { Grid, IconButton, InputAdornment } from "@material-ui/core";
import { Close as CloseIcon, Edit as EditIcon } from "@material-ui/icons";
import ClearIcon from "@material-ui/icons/Clear";
import moment from "moment-timezone";
import queryString from "query-string";
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useDataProvider } from "react-admin";
import { Field, useForm } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import { Link, useHistory } from "react-router-dom";
import { MyDateField } from "../MyDateField";
import { MyDateTimeInput } from "../MyDateTimeInput";
import { PlatformCheckboxGroupInput } from "./component/platform-components";
import { RegionCheckboxGroupInput } from "./component/region-components";
import { getJsonFromQuery, toBoolean } from "./helper";

/******************************************************************
  a list containing content_type that DO NOT has default poster
******************************************************************/
const contentTypeNoDefaultPoster = ["vodlive", "page", "horse_racecard", "horse_history", "horse_tips"];

const SlotFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Slot ID" disabled source="slot_id" alwaysOn />
  </Filter>
);

const ListActions = ({ slotId, name, type, returnTo, autoplay }) => {
  const notify = useNotify();
  const mpmLocation = returnTo || `/mpm?type=${type}`;
  const deleteRedirect = () => mpmLocation;
  const onDeleteFailure = (error) => {
    notify(error.message.toString(), "warning");
  };

  return (
    <TopToolbar>
      <div id="editorial_name" className="editorial_name">
        <label>Editorial Name: </label>
        <span>
          <b>{name}</b>
        </span>
      </div>
      <DeleteWithConfirmButton mutationMode="pessimistic" record={{ id: slotId, type: type }} redirect={deleteRedirect} onFailure={onDeleteFailure} />
      <Button
        color="primary"
        component={Link}
        to={mpmLocation}
        label="Back"
      />
      <Button
        color="primary"
        component={Link}
        to={{
          pathname: `/slots/create`,
          search: `?${queryString.stringify({ slot_id: slotId, type, autoplay, returnTo })}`,
        }}
        label="+ CREATE"
      />
      <ExportButton />
    </TopToolbar>
  );
};

export const SlotList = (props) => {
  const dataProvider = useDataProvider();
  const [mpmRowScheduleTypesResponse, setMpmRowScheduleTypesResponse] = useState();
  const [autoplay, setAutoplay] = useState(false);
  const [name, setName] = useState();

  const parsed = queryString.parse(props.location.search);
  const type = parsed.type;
  // const name = parsed.name;
  const slotId = parsed.slot_id;
  const returnTo = parsed.returnTo;

  //Get MPM Row Schedule Types
  useEffect(async () => {
    const result = await dataProvider.getMpmRowScheduleTypeByType(type);
    setAutoplay(result.data.autoplay ?? false);
    setName(result.data.name ?? "");
    setMpmRowScheduleTypesResponse(result.data);
  }, []);

  if (!mpmRowScheduleTypesResponse) {
    return <></>;
  }

  return (
    <List {...props} sort={{ field: "start_time", order: "DESC" }} filters={<SlotFilter />} actions={<ListActions slotId={slotId} name={name} type={type} returnTo={returnTo} autoplay={autoplay} />} bulkActionButtons={false} filterDefaultValues={{ slot_id: slotId, type: type }}>
      <Datagrid>
        <TextField source="content_type" />
        <ReferenceName {...props} label="Name" />
        <ImageField className="landcape-list" source="landscape_poster" />
        <MyDateField source="start_time" showTime />
        <FunctionField label="Platform" render={(record) => record.platform?.join(", ") ?? ""} />
        <FunctionField label="Region" render={(record) => record.region?.join(", ") ?? ""} />
        <CloneButton label="COPY" />
        <SlotRowEditButton slotId={slotId} type={type} autoplay={autoplay} {...props} />
        <SlotRowDeleteButton />
      </Datagrid>
    </List>
  );
};

const SlotRowEditButton = ({ slotId, type, autoplay }) => {
  const record = useRecordContext();

  return (
    <Button
      label="Edit"
      startIcon={<EditIcon />}
      onClick={() => {
        var url = `/admin/#/slots/${record.id}?slot_id=${slotId}&type=${type}&autoplay=${autoplay}`;

        window.location.href = url;
      }}
    />
  );
};

const SlotRowDeleteButton = (props) => {
  return <DeleteWithConfirmButton {...props} redirect={false} resource="/mpm-row-schedules" mutationMode="pessimistic" confirmTitle={`Delete #${props.record.id}`} onSuccess={() => window.location.reload()} />;
};

const ReferenceName = (props) => {
  if (props.record.content_type == "programme") {
    return (
      <ReferenceField source="content_id" label="Name" reference="progammes-by-prorgamme_id" link={false}>
        <ChipField source="name_tc" />
      </ReferenceField>
    );
  } else if (props.record.content_type == "live") {
    return (
      <ReferenceField source="content_id" label="Name" reference="channels-by-network_code" link={false}>
        <ChipField source="name_tc" />
      </ReferenceField>
    );
  } else if (props.record.content_type == "clip") {
    return (
      <ReferenceField source="content_id" label="Name" reference="clip-by-clip_id" link={false}>
        <ChipField source="name_tc" />
      </ReferenceField>
    );
  }

  //prevent error when content_type is none of the above
  return <></>;
};

const SlotTitle = () => {
  return <span>Edit Slot</span>;
};

const SlotFormToolbar = ({ onCancel, ...props }) => (
  <Toolbar {...props}>
    <SaveButton disabled={false} />
    <Button color="primary" label="Cancel" variant="outlined" style={{ height: 36, marginLeft: 12 }} onClick={onCancel}>
      <CloseIcon />
    </Button>
  </Toolbar>
);

export const SlotEdit = (props) => {
  const notify = useNotify();
  const posterRef = useRef();
  const history = useHistory();

  var autoplay;
  const parsed = queryString.parse(props.location.search);
  if (parsed) {
    autoplay = toBoolean(parsed.autoplay);
  }

  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };

  // get all the query string for redirect use

  const onSuccess = () => {
    history.goBack();
  };

  return (
    <Edit {...props} onFailure={onFailure} onSuccess={onSuccess} mutationMode="pessimistic" title={<SlotTitle />}>
      <SimpleForm redirect={false} toolbar={<SlotFormToolbar onCancel={() => history.goBack()} />} validate={formValidate}>
        <Field name="autoplay" component="input" type="hidden" defaultValue={autoplay} />

        <Grid container spacing={1} fullWidth>
          <Grid item sm={12} md={6}>
            <MyDateTimeInput source="start_time" validate={required()} fullWidth />
          </Grid>
          <Grid item sm={12} md={6}>
            <BooleanInput source="enabled" defaultValue={true} fullWidth />
          </Grid>
        </Grid>

        <ContentTypeSelectInput posterRef={posterRef} autoplay={autoplay} />

        <FormDataConsumer>{({ formData, ...rest }) => formData.content_type == "programme" && <ProgrammeForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>
        <FormDataConsumer>{({ formData, ...rest }) => formData.content_type == "episode" && <EpisodeForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>
        <FormDataConsumer>{({ formData, ...rest }) => formData.content_type == "live" && <ChannelForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>
        <FormDataConsumer>{({ formData, ...rest }) => formData.content_type == "vodlive" && <VodliveForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>
        <FormDataConsumer>{({ formData, ...rest }) => formData.content_type == "clip" && <ClipForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>
        <FormDataConsumer>{({ formData, ...rest }) => formData.content_type == "page" && <PageForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>
        <FormDataConsumer>{({ formData, ...rest }) => ["horse_racecard", "horse_history", "horse_tips"].includes(formData.content_type) && <HorseForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>
        <FormDataConsumer>{({ formData, ...rest }) => formData.content_type == "search" && <SearchForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>
        <FormDataConsumer>{({ formData, ...rest }) => formData.content_type == "scoopplus_short" && <ScoopPlusShortsForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>

        <Grid container spacing={1} fullWidth>
          <Grid item sm={12} md={12}>
            <RegionCheckboxGroupInput />
          </Grid>
          <Grid item sm={12} md={12}>
            <PlatformCheckboxGroupInput useDefaultValue={true} />
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};

const EpisodeSelect = (props) => {
  const dataProvider = useDataProvider();
  const [episodes, setEpisodes] = useState();

  useEffect(() => {
    if (!props.programme_id) {
      return;
    }

    dataProvider
      .getList("episodes", {
        pagination: { page: 1, perPage: 1000000 },
        sort: { field: "episode_no", order: "ASC" },
        filter: { programme_id: props.programme_id },
      })
      .then(({ data }) => {
        setEpisodes(data);
      });
  }, [props.programme_id]);

  var episodes_choices = [];

  if (episodes) {
    episodes_choices = episodes.map((episode) => ({
      id: episode.episode_id,
      name: episode.nameWithEpisodeNo,
    }));
  }

  return (
    <AutocompleteInput //
      label="Search Episode"
      source="episode_id"
      choices={episodes_choices}
      optionText="name"
      optionValue="id"
      fullWidth
      allowEmpty
    />
  );
};

const AutoCompleteProgramme = () => {
  const form = useForm();

  return (
    <ReferenceInput
      label="Search Programme Name"
      source="programme_id"
      reference="programmes-autocomplete"
      onChange={(val) => {
        //Reset all params
        form.change("episode_id", undefined);
        form.change("content_id", undefined);
        form.change("caption_tc", undefined);
        form.change("caption_en", undefined);
        form.change("programme_name_tc", undefined);
        form.change("programme_name_en", undefined);
        form.change("landscape_poster", undefined);
        form.change("portrait_poster", undefined);

        form.change("programme_id", val);
        form.change("api_timestamp", moment().valueOf());
      }}
      filterToQuery={(searchText) => {
        if (searchText) {
          return { name_tc: searchText };
        }
        return {};
      }}
    >
      <AutocompleteInput optionText="name_tc" optionValue="id" fullWidth />
    </ReferenceInput>
  );
};

const AutoCompleteClip = (props) => {
  const form = useForm();

  return (
    <ReferenceInput
      label="Search Clip Name"
      source="clip_id"
      reference="clips-autocomplete"
      onChange={(val) => {
        //Reset all params
        form.change("content_id", undefined);

        form.change("caption_tc", undefined);
        form.change("caption_en", undefined);
        form.change("clip_name_tc", undefined);
        form.change("clip_name_en", undefined);
        form.change("landscape_poster", undefined);
        form.change("portrait_poster", undefined);

        form.change("clip_id", val);
        form.change("api_timestamp", moment().valueOf());
      }}
      filterToQuery={(searchText) => {
        if (searchText) {
          return { name_tc: searchText };
        }
        return {};
      }}
      filter={{ clip_type: props.clip_type }}
    >
      <AutocompleteInput optionText="name_tc" optionValue="clip_id" fullWidth />
    </ReferenceInput>
  );
};

const AutoCompleteTCPage = () => {
  const form = useForm();
  return (
    <ReferenceInput
      label="Search MPM Page Name TC"
      source="page_id"
      reference="mpm-page-autocomplete"
      onChange={() => {
        form.change("content_id", undefined);
        form.change("caption_tc", undefined);
        form.change("caption_en", undefined);

        form.change("api_timestamp", moment().valueOf());
      }}
      filterToQuery={(searchText) => {
        if (searchText) {
          return { name_tc: searchText };
        }
        return {};
      }}
    >
      <AutocompleteInput optionText="name_tc" optionValue="id" fullWidth />
    </ReferenceInput>
  );
};

const AutoCompleteENPage = () => {
  const form = useForm();
  return (
    <ReferenceInput
      label="Search MPM Page Name EN"
      source="page_id"
      reference="mpm-page-autocomplete"
      onChange={() => {
        form.change("content_id", undefined);
        form.change("caption_tc", undefined);
        form.change("caption_en", undefined);

        form.change("api_timestamp", moment().valueOf());
      }}
      filterToQuery={(searchText) => {
        if (searchText) {
          return { name_en: searchText };
        }
        return {};
      }}
    >
      <AutocompleteInput optionText="name_en" optionValue="id" fullWidth />
    </ReferenceInput>
  );
};

const AutoCompleteChannel = () => {
  const form = useForm();

  return (
    <ReferenceInput
      label="Search Channel Name"
      source="network_code"
      reference="channels-autocomplete"
      onChange={() => {
        form.change("content_id", undefined);
        form.change("caption_tc", undefined);
        form.change("caption_en", undefined);
        form.change("landscape_poster", undefined);
        form.change("portrait_poster", undefined);

        form.change("api_timestamp", moment().valueOf());
      }}
      filterToQuery={(searchText) => {
        if (searchText) {
          return { name_tc: searchText };
        }
        return {};
      }}
    >
      <AutocompleteInput optionText="name_tc" optionValue="id" fullWidth />
    </ReferenceInput>
  );
};

const AutoCompleteVodlive = () => {
  const form = useForm();
  return (
    <ReferenceInput
      label="Search VOD-Live Name"
      source="vodlive_id"
      reference="vodlives-autocomplete"
      onChange={() => {
        form.change("content_id", undefined);
        form.change("caption_tc", undefined);
        form.change("caption_en", undefined);
        form.change("vodlive_name_tc", undefined);
        form.change("vodlive_name_en", undefined);

        form.change("api_timestamp", moment().valueOf());
      }}
      filterToQuery={(searchText) => {
        if (searchText) {
          return { name_tc: searchText };
        }
        return {};
      }}
    >
      <AutocompleteInput optionText="name_tc" optionValue="id" fullWidth />
    </ReferenceInput>
  );
};

const FetchProgrammeData = (props) => {
  const dataProvider = useDataProvider();
  const form = useForm();

  useEffect(async () => {
    if (!props.programme_id) {
      return;
    }

    const res = await dataProvider.getProgrammeByProgrammeId(props.programme_id);
    const programme = res.data;

    if (!programme) {
      return;
    }

    // const res = await dataProvider.getList("programmes", {
    //   pagination: { page: 1, perPage: 100 },
    //   sort: { field: "id", order: "ASC" },
    //   filter: { programme_id: props.programme_id.toString() },
    // });

    // if (res.data.length == 0) {
    //   return;
    // }

    // const programme = res.data[0];

    form.change("content_id", programme.programme_id);

    form.change("programme_name_tc", programme.name_tc);
    form.change("programme_name_en", programme.name_en);

    //Use caption_tc/en if exists, use programme name otherwise
    if (!props.caption_tc) {
      form.change("caption_tc", programme.name_tc);
    }
    if (!props.caption_en) {
      form.change("caption_en", programme.name_en);
    }

    form.change("landscape_poster", programme.image.landscape_large);
    form.change("portrait_poster", programme.image.portrait_large);
    if (!props.landscape_poster) {
      if (document.getElementById("pg-image")) {
        document.getElementById("pg-image").src = programme.image.landscape_large;
      } else {
        var lands = document.getElementById("landscape_poster");
        var parent = lands.parentElement;
        parent.innerHTML = '<img id="pg-image" style="margin-top:30px" width="50%" src="" />';
        parent.getElementsByTagName("img")[0].src = programme.image.landscape_large;
        lands.remove();
      }
    }

    if (!props.portrait_poster) {
      if (document.getElementById("lg-image")) {
        document.getElementById("lg-image").src = programme.image.portrait_large;
      } else {
        var port = document.getElementById("portrait_poster");
        var parentP = port.parentElement;
        parentP.innerHTML = '<img id="lg-image" style="margin-top:30px" width="30%" src="" />';
        parentP.getElementsByTagName("img")[0].src = programme.image.portrait_large;
        port.remove();
      }
    }

    // show default posters
    form.change("showDefaultPortraitPoster", true);
    form.change("showDefaultLandscapePoster", true);
  }, [props.programme_id, props.api_timestamp]);

  return null;
};

const FetchEpisodeData = (props) => {
  const dataProvider = useDataProvider();
  const form = useForm();

  useEffect(async () => {
    if (!props.episode_id) {
      return;
    }

    const res = await dataProvider.getList("episodes", {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "episode_no", order: "ASC" },
      filter: { episode_id: parseInt(props.episode_id) },
    });

    if (res.data.length == 0) {
      return;
    }

    const episode = res.data[0];

    const res2 = await dataProvider.getProgrammeByProgrammeId(episode.programme_id);
    const programme = res2.data;

    form.change("content_id", episode.episode_id);

    if (episode.name_tc) {
      form.change("caption_tc", episode.name_tc);
    } else if (moment(episode.episode_no, "YYYYMMDD", true).isValid()) {
      const x = moment(episode.episode_no, "YYYYMMDD");
      form.change("caption_tc", programme.name_tc + " " + x.format("YYYY/MM/DD"));
    } else if (isNaN(episode.episode_no)) {
      form.change("caption_tc", programme.name_tc + " " + episode.episode_no);
    } else {
      form.change("caption_tc", programme.name_tc + " 第" + episode.episode_no + "集");
    }

    if (episode.name_en) {
      form.change("caption_en", episode.name_en);
    } else if (moment(episode.episode_no, "YYYYMMDD", true).isValid()) {
      const x = moment(episode.episode_no, "YYYYMMDD");
      form.change("caption_en", programme.name_en + " " + x.format("YYYY/MM/DD"));
    } else if (isNaN(episode.episode_no)) {
      form.change("caption_en", programme.name_en + " " + episode.episode_no);
    } else {
      form.change("caption_en", programme.name_en + " Episode " + episode.episode_no);
    }

    //  if (moment(episode.episode_no, "YYYYMMDD", true).isValid()) {
    //     const x = moment(episode.episode_no, "YYYYMMDD");
    //     form.change("caption_tc", programme.name_tc + " " + x.format("YYYY/MM/DD"));
    //   } else if (isNaN(episode.episode_no)) {
    //     form.change("caption_tc", programme.name_tc + " " + episode.name_tc);
    //   } else {
    //     form.change("caption_tc", programme.name_tc + " 第" + episode.episode_no + "集");
    //   }

    // if (moment(episode.episode_no, "YYYYMMDD", true).isValid()) {
    //   const x = moment(episode.episode_no, "YYYYMMDD");
    //   form.change("caption_en", programme.name_en + " " + x.format("YYYY/MM/DD"));
    // } else if (isNaN(episode.episode_no)) {
    //   form.change("caption_en", programme.name_en + " " + episode.name_en);
    // } else {
    //   form.change("caption_en", programme.name_en + " Episode " + episode.episode_no);
    // }

    form.change("landscape_poster", episode.image.large);
    form.change("portrait_poster", episode.image.large);
    if (document.getElementById("pg-image")) {
      document.getElementById("pg-image").src = episode.image.large;
    } else {
      var lands = document.getElementById("landscape_poster");
      var parent = lands.parentElement;
      parent.innerHTML = '<img id="pg-image" style="margin-top:30px" width="50%" src="" />';
      parent.getElementsByTagName("img")[0].src = episode.image.large;
      lands.remove();
    }

    if (document.getElementById("lg-image")) {
      document.getElementById("lg-image").src = episode.image.large;
    } else {
      var port = document.getElementById("portrait_poster");
      var parentP = port.parentElement;
      parentP.innerHTML = '<img id="lg-image" style="margin-top:30px" width="30%" src="" />';
      parentP.getElementsByTagName("img")[0].src = episode.image.large;
      port.remove();
    }

    // show default posters
    form.change("showDefaultPortraitPoster", true);
    form.change("showDefaultLandscapePoster", true);
  }, [props.episode_id, props.api_timestamp]);

  return null;
};

const FetchChannelData = (props) => {
  const dataProvider = useDataProvider();
  const form = useForm();

  useEffect(async () => {
    if (!props.network_code) {
      return;
    }

    const res = await dataProvider.getList("channels", {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "id", order: "ASC" },
      filter: { network_code: props.network_code.toString() },
    });

    if (res.data.length == 0) {
      return;
    }

    const channel = res.data[0];

    form.change("content_id", channel.network_code);

    form.change("channel_name_tc", channel.name_tc);
    form.change("channel_name_en", channel.name_en);

    //Use caption_tc/en if exists, use programme name otherwise
    if (!props.caption_tc) {
      form.change("caption_tc", channel.name_tc);
    }
    if (!props.caption_en) {
      form.change("caption_en", channel.name_en);
    }

    form.change("landscape_poster", channel.landscape_poster);
    form.change("portrait_poster", channel.portrait_poster);

    if (!props.landscape_poster) {
      if (document.getElementById("pg-image")) {
        document.getElementById("pg-image").src = channel.landscape_poster;
      } else {
        var lands = document.getElementById("landscape_poster");
        var parent = lands.parentElement;
        parent.innerHTML = '<img id="pg-image" style="margin-top:30px" width="50%" src="" />';
        parent.getElementsByTagName("img")[0].src = channel.landscape_poster;
        lands.remove();
      }
    }

    if (!props.portrait_poster) {
      if (document.getElementById("lg-image")) {
        document.getElementById("lg-image").src = channel.portrait_poster;
      } else {
        var port = document.getElementById("portrait_poster");
        var parentP = port.parentElement;
        parentP.innerHTML = '<img id="lg-image" style="margin-top:30px" width="30%" src="" />';
        parentP.getElementsByTagName("img")[0].src = channel.portrait_poster;
        port.remove();
      }
    }

    // show default posters
    form.change("showDefaultPortraitPoster", true);
    form.change("showDefaultLandscapePoster", true);
  }, [props.network_code, props.api_timestamp]);

  return null;
};

const FetchVodliveData = (props) => {
  const dataProvider = useDataProvider();
  const form = useForm();

  useEffect(async () => {
    if (!props.vodlive_id) {
      return;
    }

    const res = await dataProvider.getList("vod-lives", {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "id", order: "ASC" },
      filter: { _id: props.vodlive_id.toString() },
    });

    if (res.data.length == 0) {
      return;
    }

    const vodlive = res.data[0];

    form.change("content_id", vodlive.id);

    form.change("vodlive_name_tc", vodlive.name_tc);
    form.change("vodlive_name_en", vodlive.name_en);

    //Use caption_tc/en if exists, use programme name otherwise
    if (!props.caption_tc) {
      form.change("caption_tc", vodlive.name_tc);
    }
    if (!props.caption_en) {
      form.change("caption_en", vodlive.name_en);
    }
  }, [props.vodlive_id, props.api_timestamp]);

  return null;
};

const FetchClipData = (props) => {
  const dataProvider = useDataProvider();
  const form = useForm();

  useEffect(async () => {
    if (!props.clip_id) {
      return;
    }

    const res = await dataProvider.getList("clips", {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "id", order: "ASC" },
      filter: { clip_id: props.clip_id.toString() },
    });

    if (res.data.length == 0) {
      return;
    }

    const clip = res.data[0];

    form.change("content_id", clip.clip_id);

    form.change("clip_type", clip.type);
    form.change("clip_name_tc", clip.name_tc);
    form.change("clip_name_en", clip.name_en);

    //Use caption_tc/en if exists, use programme name otherwise
    if (!props.caption_tc) {
      form.change("caption_tc", clip.name_tc);
    }
    if (!props.caption_en) {
      form.change("caption_en", clip.name_en);
    }

    form.change("landscape_poster", clip.image.landscape_large);
    form.change("portrait_poster", clip.image.portrait_large);

    if (!props.landscape_poster) {
      if (document.getElementById("pg-image")) {
        document.getElementById("pg-image").src = clip.image.landscape_large;
      } else {
        var lands = document.getElementById("landscape_poster");
        var parent = lands.parentElement;
        parent.innerHTML = '<img id="pg-image" style="margin-top:30px" width="50%" src="" />';
        parent.getElementsByTagName("img")[0].src = clip.image.landscape_large;
        lands.remove();
      }
    }

    if (!props.portrait_poster) {
      if (document.getElementById("lg-image")) {
        document.getElementById("lg-image").src = clip.image.portrait_large;
      } else {
        var port = document.getElementById("portrait_poster");
        var parentP = port.parentElement;
        parentP.innerHTML = '<img id="lg-image" style="margin-top:30px" width="30%" src="" />';
        parentP.getElementsByTagName("img")[0].src = clip.image.portrait_large;
        port.remove();
      }
    }

    // show default posters
    form.change("showDefaultPortraitPoster", true);
    form.change("showDefaultLandscapePoster", true);
  }, [props.clip_id, props.api_timestamp]);

  return null;
};

const FetchPageData = (props) => {
  const dataProvider = useDataProvider();
  const form = useForm();

  useEffect(async () => {
    if (!props.page_id) {
      return;
    }

    const res = await dataProvider.getList("mpm-pages", {
      pagination: { page: 1, perPage: 100 },
      sort: { field: "id", order: "ASC" },
      filter: { _id: props.page_id.toString() },
    });

    if (res.data.length == 0) {
      return;
    }

    const page = res.data[0];

    form.change("content_id", page.id);
  }, [props.page_id, props.api_timestamp]);

  return null;
};

const CaptionFields = () => {
  return (
    <Grid container spacing={1} fullWidth>
      <Grid item sm={12} md={6}>
        <TextInput id="caption_tc_name" label="Caption in TC" source="caption_tc" fullWidth validate={required()} />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput id="caption_en_name" label="Caption in EN" source="caption_en" fullWidth validate={required()} />
      </Grid>
    </Grid>
  );
};

// eslint-disable-next-line react/display-name
const UploadImageFields = forwardRef((props, ref) => {
  const form = useForm();
  const record = useRecordContext();

  const defaultShowCustomPortraitPoster = (() => {
    var result = record.portrait_poster_custom ? true : false;
    return result;
  })();

  const defaultShowCustomLandscapePoster = (() => {
    var result = record.landscape_poster_custom ? true : false;
    return result;
  })();

  // const [hasCustomPortraitPoster, setHasCustomPortraitPoster] = useState(defaultShowCustomPortraitPoster);
  // const [hasCustomLandscapePoster, setHasCustomLandscapePoster] = useState(defaultShowCustomLandscapePoster);

  const hasCustomPortraitPoster = form.getState().values.hasCustomPortraitPoster;
  const hasCustomLandscapePoster = form.getState().values.hasCustomLandscapePoster;

  const showCustomPortraitPoster = useCallback(() => {
    var result = defaultShowCustomPortraitPoster ? hasCustomPortraitPoster : false;
    return result;
  });

  const showCustomLandscapePoster = useCallback(() => {
    var result = defaultShowCustomLandscapePoster ? hasCustomLandscapePoster : false;
    return result;
  });

  const showDefaultPortraitPoster = useCallback(() => {
    if (contentTypeNoDefaultPoster.includes(form.getState().values.content_type)) return false;
    var result = showCustomPortraitPoster() ? false : form.getState().values.showDefaultPortraitPoster ? true : false;
    return result;
  });

  const showDefaultLandscapePoster = useCallback(() => {
    if (contentTypeNoDefaultPoster.includes(form.getState().values.content_type)) return false;
    var result = showCustomLandscapePoster() ? false : form.getState().values.showDefaultLandscapePoster ? true : false;
    return result;
  });

  const resetPortraitPoster = useCallback(() => {
    form.change("portrait_poster_base64", null);
    form.change("portrait_poster_custom", null);
    form.change("hasCustomPortraitPoster", false);
  });

  const resetLandscapePoster = useCallback(() => {
    form.change("landscape_poster_base64", null);
    form.change("landscape_poster_custom", null);
    form.change("hasCustomLandscapePoster", false);
  });

  const onChangeProgramme = () => {
    resetPortraitPoster();
    resetLandscapePoster();
  };

  useImperativeHandle(ref, () => ({
    resetPoster() {
      resetPortraitPoster();
      resetLandscapePoster();

      // also reset the default program poster
      form.change("portrait_poster", undefined);
      form.change("landscape_poster", undefined);
      form.change("showDefaultPortraitPoster", false);
      form.change("showDefaultLandscapePoster", false);
    },
  }));

  return (
    <>
      {/* type="hidden" */}
      <Field name="showDefaultPortraitPoster" component="input" type="hidden" defaultValue={true} />
      <Field name="showDefaultLandscapePoster" component="input" type="hidden" defaultValue={true} />
      <Field name="hasCustomPortraitPoster" component="input" type="hidden" defaultValue={defaultShowCustomPortraitPoster} />
      <Field name="hasCustomLandscapePoster" component="input" type="hidden" defaultValue={defaultShowCustomLandscapePoster} />

      <OnChange name="api_timestamp">{onChangeProgramme}</OnChange>
      <OnChange name="programme_id">{onChangeProgramme}</OnChange>

      <Grid container spacing={1} fullWidth>
        <Grid item xs={12} sm={12} md={12}>
          <h3>Posters</h3>
        </Grid>
      </Grid>
      <Grid container spacing={1} fullWidth>
        {/* Portrait Section */}
        <Grid item xs={12} sm={12} md={6}>
          <Grid container spacing={1} fullWidth>
            <Grid item xs={12} sm={12} md={12} style={showDefaultPortraitPoster() ? {} : { display: "none" }}>
              <ImageField id="portrait_poster" label={<LabelImagePortrait />} source="portrait_poster" fullWidth />
            </Grid>
            <Grid item xs={12} sm={12} md={12} style={showCustomPortraitPoster() ? {} : { display: "none" }}>
              <ImageField id="portrait_poster_custom" label={<CustomLabelImagePortrait />} source="portrait_poster_custom" fullWidth />
            </Grid>
            <Grid item xs={12} sm={12} md={12} style={showCustomPortraitPoster() ? {} : { display: "none" }}>
              <Button label="Reset to default Portrait Poster" variant="outlined" onClick={resetPortraitPoster} />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <ImageInput source="portrait_poster_base64" label={<LabelImagePortrait />} accept="image/*">
                <ImageField source="src" title="title" />
              </ImageInput>
            </Grid>
          </Grid>
        </Grid>

        {/* Landscape Section */}
        <Grid item sm={12} md={6}>
          <Grid container spacing={1} fullWidth>
            <Grid item xs={12} sm={12} md={12} style={showDefaultLandscapePoster() ? {} : { display: "none" }}>
              <ImageField id="landscape_poster" label={<LabelImageLandscape />} source="landscape_poster" fullWidth />
            </Grid>
            <Grid item xs={12} sm={12} md={12} style={showCustomLandscapePoster() ? {} : { display: "none" }}>
              <ImageField id="landscape_poster_custom" label={<CustomLabelImageLandscape />} source="landscape_poster_custom" fullWidth />
            </Grid>
            <Grid item xs={12} sm={12} md={12} style={showCustomLandscapePoster() ? {} : { display: "none" }}>
              <Button label="Reset to default Landscape Poster" variant="outlined" onClick={resetLandscapePoster} />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <ImageInput source="landscape_poster_base64" label={<LabelImageLandscape />} accept="image/*">
                <ImageField source="src" title="title" />
              </ImageInput>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
});

const StartTime = () => {
  return <MyDateTimeInput disabled={false} source="start_time" validate={required()} fullWidth />;
};

const formValidate = (values) => {
  const errors = {};

  if (values.autoplay) {
    if (values.content_type != "episode" && values.content_type != "clip") {
      errors.content_type = "Autoplay only support Episode or Clip";
    }
  }

  if (values.content_type == "programme") {
    // programme dont need custom upload

    // content id
    if (!values.content_id && !values.programme_id) {
      errors.content_id = "Required";
    }
  } else if (values.content_type == "live") {
    // programme dont need custom upload

    // content id
    if (!values.content_id && !values.network_code) {
      errors.content_id = "Required";
    }
  } else if (values.content_type == "vodlive") {
    // content id
    if (!values.content_id && !values.vodlive_id) {
      errors.content_id = "Required";
    }
    // need custom upload
    if (!values.landscape_poster_base64 && !values.landscape_poster_custom) {
      errors.landscape_poster_base64 = "Required";
    }
  } else if (values.content_type == "clip") {
    // programme dont need custom upload

    // content id
    if (!values.content_id && !values.clip_id) {
      errors.content_id = "Required";
    }
  } else if (values.content_type == "episode") {
    // programme dont need custom upload

    // content id
    if (!values.content_id && !values.episode_id) {
      errors.content_id = "Required";
    }
  } else if (values.content_type == "page") {
    // content id
    if (!values.content_id && !values.episode_id) {
      errors.content_id = "Required";
    }

    // programme need custom upload
    if (!values.landscape_poster_base64 && !values.landscape_poster_custom) {
      errors.landscape_poster_base64 = "Required";
    }
  } else {
    if (!values.landscape_poster_base64 && !values.landscape_poster && !values.landscape_poster_custom) {
      errors.landscape_poster_base64 = "Required";
    }
  }

  // Portrait is not mandatory
  // if (!values.portrait_poster_base64 && !values.portrait_poster) {
  //   errors.portrait_poster_base64 = "Required";
  // }

  return errors;
};

const ContentTypeSelectInput = (props) => {
  const form = useForm();

  var choices;
  var defaultValue;
  if (props.autoplay) {
    choices = [
      { id: "clip", name: "Clip" },
      { id: "episode", name: "Episode" },
    ];
    defaultValue = "episode";
  } else {
    choices = [
      { id: "programme", name: "Programme" },
      { id: "live", name: "Live" },
      { id: "vodlive", name: "VOD-Live" },
      { id: "clip", name: "Clip" },
      { id: "episode", name: "Episode" },
      { id: "page", name: "Page" },
      { id: "horse_racecard", name: "Horse Racecard" },
      { id: "horse_history", name: "Horse History" },
      { id: "horse_tips", name: "Horse Tips" },
      { id: "search", name: "Search" },
      { id: "scoopplus_short", name: "Scoop Plus Shorts" },
    ];
    defaultValue = "programme";
  }

  return (
    <Grid container spacing={1} fullWidth>
      <Grid item sm={12} md={12}>
        <SelectInput
          source="content_type"
          choices={choices}
          defaultValue={defaultValue}
          fullWidth
          onChange={() => {
            form.change("landscape_poster", undefined); //Reset param
            form.change("portrait_poster", undefined); //Reset param
            form.change("content_id", null); //Reset param

            // trigger custom poster reset
            props.posterRef.current.resetPoster();
          }}
        />
      </Grid>
    </Grid>
  );
};
export const SlotCreate = (props) => {
  const notify = useNotify();
  const posterRef = useRef();
  const redirectTo = useRedirect();
  const history = useHistory();

  const parsed = queryString.parse(props.location.search);

  var id;
  var type;
  var autoplay;

  if (parsed) {
    //Clone
    if (parsed.source) {
      const j = JSON.parse(parsed.source);

      id = j.slot_id;
      type = j.type;
      autoplay = toBoolean(j.autoplay);
    } else {
      //Normal create
      id = parsed.slot_id;
      type = parsed.type;
      autoplay = toBoolean(parsed.autoplay);
    }
  }

  const onSuccess = () => {
    const url = `/slots?slot_id=${id}&type=${type}`;
    redirectTo(url);
  };

  const onFailure = (error) => {
    notify(error.message.toString(), "warning");
  };

  return (
    <Create {...props} onSuccess={onSuccess} onFailure={onFailure} title="Create Slot">
      <SimpleForm method="POST" toolbar={<SlotFormToolbar onCancel={() => history.goBack()} />} validate={formValidate}>
        <Field name="autoplay" component="input" type="hidden" defaultValue={autoplay} />

        <Grid item fullWidth>
          <NumberInput disabled type="number" source="slot_id" defaultValue={id} fullWidth />
        </Grid>

        <Grid container spacing={1} fullWidth>
          <Grid item sm={12} md={6}>
            <FormDataConsumer>{({ formData, ...rest }) => <StartTime formData={formData} rest={rest} />}</FormDataConsumer>
          </Grid>
          <Grid item sm={12} md={6}>
            <BooleanInput source="enabled" defaultValue={true} fullWidth />
          </Grid>
        </Grid>

        <ContentTypeSelectInput posterRef={posterRef} autoplay={autoplay} />

        <FormDataConsumer>{({ formData, ...rest }) => formData.content_type == "programme" && <ProgrammeForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>
        <FormDataConsumer>{({ formData, ...rest }) => formData.content_type == "episode" && <EpisodeForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>
        <FormDataConsumer>{({ formData, ...rest }) => formData.content_type == "live" && <ChannelForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>
        <FormDataConsumer>{({ formData, ...rest }) => formData.content_type == "vodlive" && <VodliveForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>
        <FormDataConsumer>{({ formData, ...rest }) => formData.content_type == "clip" && <ClipForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>
        <FormDataConsumer>{({ formData, ...rest }) => formData.content_type == "page" && <PageForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>
        <FormDataConsumer>{({ formData, ...rest }) => ["horse_racecard", "horse_history", "horse_tips"].includes(formData.content_type) && <HorseForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>
        <FormDataConsumer>{({ formData, ...rest }) => formData.content_type == "search" && <SearchForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>
        <FormDataConsumer>{({ formData, ...rest }) => formData.content_type == "scoopplus_short" && <ScoopPlusShortsForm formData={formData} rest={rest} posterRef={posterRef} />}</FormDataConsumer>

        <Grid container spacing={1} fullWidth>
          <Grid item sm={12} md={12}>
            <RegionCheckboxGroupInput />
          </Grid>
          <Grid item sm={12} md={12}>
            <PlatformCheckboxGroupInput useDefaultValue={true} />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};

const ProgrammeForm = ({ formData, rest, posterRef }) => {
  formData.portrait_poster = null;
  formData.landscape_poster = null;

  return (
    <Grid container spacing={1} fullWidth>
      <FetchProgrammeData {...formData} programme_id={formData.programme_id ?? formData.content_id} />
      <Grid item sm={12} md={6}>
        <AutoCompleteProgramme clearAlwaysVisible={true} fullWidth {...rest} allowEmpty={true} />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Content ID" source="content_id" disabled fullWidth />
      </Grid>
      <CaptionFields fullWidth />
      {/* <ProgrammeInput fullWidth /> */}

      <UploadImageFields ref={posterRef} />

      <Field name="programme_name_tc" component="input" type="hidden" />
      <Field name="programme_name_en" component="input" type="hidden" />
      <TypeHiddenField value={formData.type} />
      <Field name="api_timestamp" component="input" type="hidden" />
    </Grid>
  );
};

const EpisodeForm = ({ formData, rest, posterRef }) => {
  formData.portrait_poster = null;
  formData.landscape_poster = null;

  return (
    <Grid container spacing={1} fullWidth>
      <FetchEpisodeData {...formData} episode_id={formData.episode_id ?? formData.content_id} />
      <Grid item sm={12} md={4}>
        <AutoCompleteProgramme clearAlwaysVisible={true} fullWidth {...rest} allowEmpty={true} />
      </Grid>
      <Grid item sm={12} md={4}>
        <EpisodeSelect programme_id={formData.programme_id} {...rest} fullWidth />
      </Grid>
      <Grid item sm={12} md={4}>
        <TextInput label="Content ID" source="content_id" disabled fullWidth />
      </Grid>
      <CaptionFields fullWidth />

      <UploadImageFields ref={posterRef} />

      <TypeHiddenField />
      <Field name="programme_name_tc" component="input" type="hidden" />
      <Field name="programme_name_en" component="input" type="hidden" />
      <Field name="api_timestamp" component="input" type="hidden" />
    </Grid>
  );
};

const ChannelForm = ({ formData, rest, posterRef }) => {
  formData.portrait_poster = null;
  formData.landscape_poster = null;

  return (
    <Grid container spacing={1} fullWidth>
      <FetchChannelData {...formData} network_code={formData.network_code ?? formData.content_id} />
      <Grid item sm={12} md={6}>
        <AutoCompleteChannel clearAlwaysVisible={true} fullWidth {...rest} allowEmpty={true} />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Content ID" source="content_id" disabled fullWidth />
      </Grid>
      <CaptionFields fullWidth />

      <UploadImageFields ref={posterRef} />

      <TypeHiddenField />
      <Field name="channel_name_tc" component="input" type="hidden" />
      <Field name="channel_name_en" component="input" type="hidden" />
      <Field name="api_timestamp" component="input" type="hidden" />
    </Grid>
  );
};

const VodliveForm = ({ formData, rest, posterRef }) => {
  formData.portrait_poster = null;
  formData.landscape_poster = null;

  return (
    <Grid container spacing={1} fullWidth>
      <FetchVodliveData {...formData} vodlive_id={formData.vodlive_id ?? formData.content_id} />
      <Grid item sm={12} md={6}>
        <AutoCompleteVodlive clearAlwaysVisible={true} fullWidth {...rest} allowEmpty={true} />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Content ID" source="content_id" disabled fullWidth />
      </Grid>
      <CaptionFields fullWidth />
      {/* <VodliveInput fullWidth /> */}

      <UploadImageFields ref={posterRef} />

      <TypeHiddenField />
      <Field name="vodlive_name_tc" component="input" type="hidden" />
      <Field name="vodlive_name_en" component="input" type="hidden" />
      <Field name="api_timestamp" component="input" type="hidden" />
    </Grid>
  );
};

const ClipForm = ({ formData, rest, posterRef }) => {
  formData.portrait_poster = null;
  formData.landscape_poster = null;

  return (
    <Grid container spacing={1} fullWidth>
      <FetchClipData {...formData} clip_id={formData.clip_id ?? formData.content_id} />
      <Grid item sm={12} md={12}>
        <ReferenceInput label="Clip Type" source="clip_type" reference="clips-type" fullWidth>
          <SelectInput optionText="name" optionValue="id" />
        </ReferenceInput>
      </Grid>
      <Grid item sm={12} md={6}>
        <AutoCompleteClip clip_type={formData.clip_type} clearAlwaysVisible={true} fullWidth {...rest} allowEmpty={true} />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Content ID" source="content_id" disabled fullWidth />
      </Grid>
      <CaptionFields fullWidth />

      <UploadImageFields ref={posterRef} />

      <TypeHiddenField />
      <Field name="clip_name_tc" component="input" type="hidden" />
      <Field name="clip_name_en" component="input" type="hidden" />
      <Field name="api_timestamp" component="input" type="hidden" />
    </Grid>
  );
};

const PageForm = ({ formData, rest, posterRef }) => {
  formData.portrait_poster = null;
  formData.landscape_poster = null;

  return (
    <Grid container spacing={1} fullWidth>
      <FetchPageData {...formData} page_id={formData.page_id ?? formData.content_id} />
      <Grid item sm={12} md={6}>
        <AutoCompleteTCPage clearAlwaysVisible={true} fullWidth {...rest} allowEmpty={true} />
      </Grid>
      <Grid item sm={12} md={6}>
        <AutoCompleteENPage clearAlwaysVisible={true} fullWidth {...rest} allowEmpty={true} />
      </Grid>
      <Grid item sm={12} md={12}>
        <TextInput label="Content ID" source="content_id" disabled fullWidth />
      </Grid>
      <CaptionFields fullWidth />

      <UploadImageFields ref={posterRef} />

      {/* <PageInput fullWidth /> */}
      <TypeHiddenField />
      <Field name="api_timestamp" component="input" type="hidden" />
    </Grid>
  );
};

const HorseForm = ({ formData, posterRef }) => {
  formData.portrait_poster = null;
  formData.landscape_poster = null;

  return (
    <Grid container spacing={1} fullWidth>
      <CaptionFields fullWidth />

      <UploadImageFields ref={posterRef} />

      <TypeHiddenField />
    </Grid>
  );
};

const SearchForm = ({ formData, posterRef }) => {
  formData.portrait_poster = null;
  formData.landscape_poster = null;

  return (
    <Grid container spacing={1} fullWidth>
      <Grid item sm={12} md={12}>
        <TextInput label="Search keyword" source="search_keyword" validate={required()} fullWidth />
      </Grid>

      <CaptionFields fullWidth />

      <UploadImageFields ref={posterRef} />

      <TypeHiddenField />
    </Grid>
  );
};

export const ScoopPlusShortsForm = ({ formData, posterRef }) => {
  const dataProvider = useDataProvider();
  const [channels, setChannels] = useState();
  const form = useForm();

  const handleRemove = () => {
    form.change("channel_id", null);
    form.change("channel_name", null);
  };

  useEffect(() => {
    //Assign ref_x to channel_id for easily understanding
    formData.channel_id = formData.content_id;

    dataProvider
      .getList("scoopplus-shorts-channel")
      // .getList("scoopplus-shorts-channel", {
      //   pagination: { page: 1, perPage: 1000000 },
      //   sort: { field: "episode_no", order: "ASC" },
      //   filter: { programme_id: props.programme_id },
      // })
      .then(({ data }) => {
        setChannels(data);

        if (formData.channel_id) {
          const c = data.find((c) => c.id == formData.channel_id);
          form.change("channel_id", c.id);
          form.change("channel_name", c.name);
        }
      });
  }, []);

  var channels_choices = [];

  if (channels) {
    channels_choices = channels.map((channel) => ({
      id: channel.id,
      name: channel.name,
      // name: `${channel.name} - ${channel.id}`,
    }));
  }

  const OptionRenderer = (choice) => {
    if (choice?.record?.id) {
      return `${choice.record.name} - ${choice.record.id}`;
    }
    return "";
  };

  const inputText = (choice) => choice.name;
  return (
    <Grid container spacing={1} fullWidth>
      <Grid item sm={12} md={12}>
        <AutocompleteInput //
          label="Search Channel Name / Parent Channel Name"
          source="channel_id"
          choices={channels_choices}
          optionText={<OptionRenderer />}
          inputText={inputText}
          matchSuggestion={(filterValue, suggestion) => (suggestion.name && suggestion.name.toLowerCase().includes(filterValue.toLowerCase())) || (suggestion.id && suggestion.id.toString().includes(filterValue))}
          // optionText="name"
          optionValue="id"
          fullWidth
          allowEmpty
          options={{
            InputProps: {
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleRemove} edge="end" style={{ color: "red" }}>
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
          onChange={(val) => {
            form.change("channel_id", val);
            form.change("channel_name", val ? channels.find((c) => c.id == val).name : null);
          }}
        />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Name" source="channel_name" disabled fullWidth />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextInput label="Channel ID" source="channel_id" disabled fullWidth />
      </Grid>

      <CaptionFields fullWidth />
      <UploadImageFields ref={posterRef} />
    </Grid>
  );
};

const TypeHiddenField = ({ value }) => {
  if (!value) {
    const json = getJsonFromQuery(document.location.href);

    if (json.type) {
      value = json.type;
    }
  }

  return <Field name="type" component="input" type="hidden" defaultValue={value} />;
};

const LabelImagePortrait = () => {
  let slot_str = document.location;
  let type = "";
  if (slot_str.href.split("type=").length > 1) {
    type = slot_str.href.split("type=")[1];
  }
  if (type == "horserace_2") {
    return "Portrait";
  } else {
    return "Portrait - 200 x 290";
  }
};

const LabelImageLandscape = () => {
  let slot_str = document.location;
  let type = "";
  if (slot_str.href.split("type=").length > 1) {
    type = slot_str.href.split("type=")[1];
  }
  if (type == "horserace_2") {
    return "Landscape only: 1920 x 1080";
  } else {
    return "Landscape - 615 x 346";
  }
};

const CustomLabelImagePortrait = () => {
  let slot_str = document.location;
  let type = "";
  if (slot_str.href.split("type=").length > 1) {
    type = slot_str.href.split("type=")[1];
  }
  if (type == "horserace_2") {
    return "Custom Portrait";
  } else {
    return "Custom Portrait - 200 x 290";
  }
};

const CustomLabelImageLandscape = () => {
  let slot_str = document.location;
  let type = "";
  if (slot_str.href.split("type=").length > 1) {
    type = slot_str.href.split("type=")[1];
  }
  if (type == "horserace_2") {
    return "Custom Landscape only: 1920 x 1080";
  } else {
    return "Custom Landscape - 615 x 346";
  }
};
